import { root, id } from './contacts';

export const contacts = {
  ...root,
  id: id,
};
